const commentsStyle = Object.freeze({
  textInputVariant: 'neutral',
  sendButtonVariant: 'neutral',
  hideIdentifiedCommentsButtons: false,
  formFontStack: 'base',
});

export default commentsStyle;
